import { SYSAction } from "../../../../_ovlclient/src"
import {
  FieldSetVal,
  type SYSFormState,
} from "../../../../_ovlclient/src/library/forms/fieldapi"

import {
  ProcessEnd,
  ProcessIsRunning,
  ProcessStart,
} from "../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import { Data } from "../../../src/dataapi"
import { DialogClose } from "../../../src/library/dialog/dialogapi"
import { DialogsState } from "../../../src/library/dialog/sysdialogbase"
import { SnackAdd } from "../../../src/library/snackapi"

const Verify: SYSAction<{
  formState: SYSFormState
  dialogState: DialogsState
  requestKey: string
  code: string
}> = async (value, { global }) => {
  let dialogState = value.dialogState

  ProcessStart("SYSTOTP", {
    lock: {
      dialog: dialogState.dialog,
      dialogInstance: dialogState.instance,
      formState: value.formState,
    },
  })

  try {
    var res = await Data("users/totp", {
      code: value.code,
      requestKey: value.requestKey,
    })
    DialogClose("SYSTOTP", {
      instance: dialogState.instance,
      resolveValue: res,
    })
  } catch (e) {
    if (e.type === "InvalidCredentials") {
      SnackAdd(e.message, "Error")
    }
    setTimeout(() => {
      for (let i = 1; i <= 6; i++) {
        let fkey = `TOTPDigit${i}`
        FieldSetVal(value.formState.fields[fkey], null, {
          ignoreValueChanged: true,
        })
      }
    }, 0)
  } finally {
    ProcessEnd("SYSTOTP")
  }
}

export let actions = { Verify }
